import { z } from 'zod';
import { cursorQuerySchema, uuidSchema } from './common';

export const sendMessageSchema = z.object({
  clientMsgId: uuidSchema,
  type: z.enum(['text', 'image']).default('text'),
  body: z.string().min(1).max(1000).optional(),
  imagePath: z.string().max(500).optional(),
})
  .refine((v) => (v.type === 'text' ? !!v.body : !!v.imagePath), {
    message: 'text 메시지는 body, image 메시지는 imagePath가 필요합니다',
  });
export type SendMessageInput = z.infer<typeof sendMessageSchema>;

export const listMessagesQuerySchema = cursorQuerySchema.extend({
  /** seq 미만의 과거 메시지 백필 */
  beforeSeq: z.coerce.number().int().positive().optional(),
  /** seq 초과의 누락 메시지 갭 복구 */
  afterSeq: z.coerce.number().int().nonnegative().optional(),
});
export type ListMessagesQuery = z.infer<typeof listMessagesQuerySchema>;

export const markReadSchema = z.object({
  lastReadSeq: z.number().int().nonnegative(),
});
export type MarkReadInput = z.infer<typeof markReadSchema>;

export const retranslateSchema = z.object({
  messageId: uuidSchema,
});
